var users = [
    {
        "lastname": "Мухина", "firstname": "Ольга", "patronymic": "Ивановна"
    },
    {
        "lastname": "Третьякова", "firstname": "Кира", "patronymic": "Михайловна"
    },
    {
        "lastname": "Комарова", "firstname": "Аврора", "patronymic": "Ивановна"
    },
    {
        "lastname": "Иванова", "firstname": "Олеся", "patronymic": "Семёновна"
    },
    {
        "lastname": "Лаврова", "firstname": "Аделина", "patronymic": "Александровна"
    },
    {
        "lastname": "Тарасов", "firstname": "Михаил", "patronymic": "Ильич"
    },
    {
        "lastname": "Голубев", "firstname": "Дмитрий", "patronymic": "Александрович"
    },
    {
        "lastname": "Киселев", "firstname": "Андрей", "patronymic": "Михайлович"
    },
    {
        "lastname": "Давыдова", "firstname": "Алёна", "patronymic": "Ивановна"
    },
    {
        "lastname": "Кузнецов", "firstname": "Артём", "patronymic": "Леонидович"
    },
    {
        "lastname": "Суркова", "firstname": "Алиса", "patronymic": "Фёдоровна"
    },
    {
        "lastname": "Федорова", "firstname": "Алина", "patronymic": "Матвеевна"
    },
    {
        "lastname": "Макаров", "firstname": "Максим", "patronymic": "Алексеевич"
    },
    {
        "lastname": "Черняева", "firstname": "Милана", "patronymic": "Матвеевна"
    },
    {
        "lastname": "Денисов", "firstname": "Константин", "patronymic": "Денисович"
    },
    {
        "lastname": "Сахарова", "firstname": "Вероника", "patronymic": "Глебовна"
    },
    {
        "lastname": "Зайцев", "firstname": "Роман", "patronymic": "Матвеевич"
    },
    {
        "lastname": "Нестеров", "firstname": "Виктор", "patronymic": "Янович"
    },
    {
        "lastname": "Зайцева", "firstname": "Мария", "patronymic": "Данииловна"
    },
    {
        "lastname": "Пономарева", "firstname": "Алиса", "patronymic": "Дамировна"
    },
    {
        "lastname": "Денисов", "firstname": "Арсений", "patronymic": "Павлович"
    },
    {
        "lastname": "Васильев", "firstname": "Алексей", "patronymic": "Ярославович"
    },
    {
        "lastname": "Овчинникова", "firstname": "Злата", "patronymic": "Ивановна"
    },
    {
        "lastname": "Корнеев", "firstname": "Матвей", "patronymic": "Кириллович"
    },
    {
        "lastname": "Богомолова", "firstname": "Екатерина", "patronymic": "Никитична"
    },
    {
        "lastname": "Соболева", "firstname": "Варвара", "patronymic": "Вадимовна"
    },
    {
        "lastname": "Иванова", "firstname": "Вера", "patronymic": "Егоровна"
    },
    {
        "lastname": "Кожевников", "firstname": "Иван", "patronymic": "Александрович"
    },
    {
        "lastname": "Баранов", "firstname": "Лев", "patronymic": "Богданович"
    },
    {
        "lastname": "Соловьев", "firstname": "Марк", "patronymic": "Ярославович"
    },
    {
        "lastname": "Левин", "firstname": "Владислав", "patronymic": "Артемьевич"
    },
    {
        "lastname": "Лебедев", "firstname": "Кирилл", "patronymic": "Робертович"
    },
    {
        "lastname": "Плотников", "firstname": "Мирон", "patronymic": "Александрович"
    },
    {
        "lastname": "Зайцева", "firstname": "София", "patronymic": "Константиновна"
    },
    {
        "lastname": "Муравьева", "firstname": "Анастасия", "patronymic": "Яковлевна"
    },
    {
        "lastname": "Хомяков", "firstname": "Дмитрий", "patronymic": "Маркович"
    },
    {
        "lastname": "Усов", "firstname": "Елисей", "patronymic": "Григорьевич"
    },
    {
        "lastname": "Трофимов", "firstname": "Максим", "patronymic": "Львович"
    },
    {
        "lastname": "Меркулов", "firstname": "Михаил", "patronymic": "Ильич"
    },
    {
        "lastname": "Чернов", "firstname": "Михаил", "patronymic": "Семёнович"
    },
    {
        "lastname": "Соколова", "firstname": "Полина", "patronymic": "Павловна"
    },
    {
        "lastname": "Белоусова", "firstname": "Ева", "patronymic": "Георгиевна"
    },
    {
        "lastname": "Горохов", "firstname": "Алексей", "patronymic": "Маркович"
    },
    {
        "lastname": "Семенов", "firstname": "Александр", "patronymic": "Александрович"
    },
    {
        "lastname": "Морозова", "firstname": "Анна", "patronymic": "Матвеевна"
    },
    {
        "lastname": "Колесников", "firstname": "Матвей", "patronymic": "Викторович"
    },
    {
        "lastname": "Севастьянов", "firstname": "Иван", "patronymic": "Михайлович"
    },
    {
        "lastname": "Логинова", "firstname": "Елизавета", "patronymic": "Ивановна"
    },
    {
        "lastname": "Семенов", "firstname": "Даниил", "patronymic": "Матвеевич"
    },
    {
        "lastname": "Смирнова", "firstname": "Дарина", "patronymic": "Данииловна"
    }
];

export default users;